import * as L from 'leaflet';
import {
  ParamsCreatePolyline,
  ResponseCreatePolyline,
} from '../models/manager-leaflet.model';
import { adaptCoordsToPolyline } from '../adapters/adapt-Coords-Polyline.adapter';

const DEFAULT_OPTIONS: L.PolylineOptions = {
  color: '#2563EB',
  opacity: 1,
  weight: 2,
  interactive: false,
};

export function createPolyline(
  params: ParamsCreatePolyline
): ResponseCreatePolyline {
  try {
    const { coordinates } = params;

    // VALIDACIONES
    if (!coordinates || coordinates.length === 0) {
      return {
        polyline: L.polyline([]),
        error: 'No se detecto ningún movimiento en el periodo seleccionado',
      };
    }
    const validCoords = coordinates.every(
      (coord) =>
        typeof coord.latitude === 'number' &&
        typeof coord.longitude === 'number' &&
        !isNaN(coord.latitude) &&
        !isNaN(coord.longitude)
    );
    if (!validCoords) {
      return {
        polyline: L.polyline([]),
        error: 'Las coordenadas deben ser números válidos',
      };
    }

    const options: L.PolylineOptions = {
      ...DEFAULT_OPTIONS,
      ...(params.options ?? {}),
      // interactive: false,
    };

    // CREAR EL POLYLINE
    const adaptCoordinates = adaptCoordsToPolyline(coordinates);
    const polyline = L.polyline(adaptCoordinates, options);
    if (!polyline) {
      return {
        polyline: L.polyline([]),
        error: 'No se pudo crear el polyline',
      };
    }
    return { polyline, error: null };
  } catch (error) {
    return {
      polyline: L.polyline([]),
      error: 'Error desconocido al crear polyline',
    };
  }
}
